import React from "react";

import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";

import { ILoaderProps } from "./definitions";
import styles from "./style.module.scss";

export const LoaderBox: React.FC<ILoaderProps> = ({ loadingText, height }) => {
    return (
        <Box className={height ? styles.smallLoader : styles.loader} data-testid="loader">
            <Box>
                <Loader size="large" type="circular" />
            </Box>
            {loadingText && <Box>{loadingText}</Box>}
        </Box>
    );
};

export default LoaderBox;
